export const DEFAULT_BACKGROUND_COLORS = ['darkgrey', 'lightgrey'];
export const DEFAULT_TEXT_COLORS = ['black'];
export const DEFAULT_OUTER_BORDER_COLOR = '#292016';
export const DEFAULT_OUTER_BORDER_WIDTH = 15;
export const DEFAULT_INNER_RADIUS = 40;
export const DEFAULT_INNER_BORDER_COLOR = '#292016';
export const DEFAULT_INNER_BORDER_WIDTH = 30;
export const DEFAULT_RADIUS_LINE_COLOR = '#fab878';
export const DEFAULT_RADIUS_LINE_WIDTH = 3;
export const DEFAULT_FONT_SIZE = 18;
export const DEFAULT_TEXT_DISTANCE = 80;
export const DEFAULT_SPIN_DURATION = 0.25;
// export const DEFAULT_BACKGROUND_COLORS = ['darkgrey', 'lightgrey'];
// export const DEFAULT_TEXT_COLORS = ['black'];
// export const DEFAULT_OUTER_BORDER_COLOR = 'black';
// export const DEFAULT_OUTER_BORDER_WIDTH = 5;
// export const DEFAULT_INNER_RADIUS = 0;
// export const DEFAULT_INNER_BORDER_COLOR = 'black';
// export const DEFAULT_INNER_BORDER_WIDTH = 0;
// export const DEFAULT_RADIUS_LINE_COLOR = 'black';
// export const DEFAULT_RADIUS_LINE_WIDTH = 5;
// export const DEFAULT_FONT_SIZE = 20;
// export const DEFAULT_TEXT_DISTANCE = 60;
// export const DEFAULT_SPIN_DURATION = 1.0;
